import { useLocation } from 'react-router';
import { SiteUrl } from '@/constants/site';
import { formatPageTitle } from '@/lib/pageTitle';

export function PageMeta({ title, description, noIndex = false }) {
  const { pathname } = useLocation();

  return (
    <>
      <title>{formatPageTitle(title)}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={`${SiteUrl}${pathname}`} />
      {noIndex ? <meta name="robots" content="noindex" /> : null}
    </>
  );
}